/**
 * SpriteIcon Component
 * Renders an icon from the sprite atlas (/icons/icons.png) using CSS background-position.
 */

import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector } from '../../store/hooks';

const ATLAS_URL = '/icons/icons.png';
const ATLAS_WIDTH = 1012;
const ATLAS_HEIGHT = 492;

const SpriteIcon = ({ iconName, size = 32 }) => {
  const { iconData, iconsLoaded } = useAppSelector((state) => state.ui);

  if (!iconsLoaded || !iconData) return null;

  // Try with .png extension, then without
  const key = iconData[iconName] ? iconName
    : iconData[`${iconName}.png`] ? `${iconName}.png`
    : null;

  if (!key) return null;

  const frame = iconData[key];
  const scaleX = size / frame.width;
  const scaleY = size / frame.height;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        backgroundImage: `url(${ATLAS_URL})`,
        backgroundPosition: `-${frame.x * scaleX}px -${frame.y * scaleY}px`,
        backgroundSize: `${ATLAS_WIDTH * scaleX}px ${ATLAS_HEIGHT * scaleY}px`,
        backgroundRepeat: 'no-repeat',
        flexShrink: 0,
      }}
    />
  );
};

export default SpriteIcon;
